export class JourneyType {
  static STANDARD = 1
  static ROUND = 2
  static SHUTTLE = 3
  static EMPTY = 4
}

export class JourneyType2 {
  static STANDARD_MONO = 11
  static STANDARD_MULTI = 12
  static STANDARD_EMPTY = 13
  static STANDARD_MULTI_ROOT = 14
  static STANDARD_MULTI_CHILDREN = 15
  static STANDARD_MULTI_END = 16

  static ROUND_COLLECTION = 21
  static ROUND_DISTRIBUTION = 22
  static ROUND_COLLECTION_AND_DISTRIBUTION = 23

  static SHUTTLE_ONLY_OUTWARD = 31
  static SHUTTLE_ONLY_RETURN = 32
  static SHUTTLE_OUTWARD_AND_RETURN = 33

  static ROUND_OR_SHUTTLE_EMPTY = 40
}

export class JourneyType3 {
  static STOPPED_VEHICLES = 0
  static STANDARD_MONO = 1
  static STANDARD_MULTI = 2
  static ROUND = 3
  static STANDARD_EMPTY = 4
  static SHUTTLE = 5
  static ROUND_OR_SHUTTLE_EMPTY = 6
  static _ROUND_AND_SHUTTLE = 7 // Unsed
}

export class RoundType {
  static COLLECTION = 1
  static DISTRIBUTION = 2
  static SHUTTLE = 3
  static ROUND_COLLECTION_AND_DISTRIBUTION = 4
}
